import React from "react";
import { FormattedMessage } from "react-intl";
import css from "./ProvisionalBadge.module.css";
export var ProvisionalBadge = function () { return (React.createElement("span", { className: css.provisionalBadge },
    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.badge" }))); };
